import type { EmailVerificationSource } from "./email-verification";

type AutoSendEmailOtpOptions = {
  source?: EmailVerificationSource;
  otpSentAt?: number | null;
};

type EmailVerificationRequiredErrorOptions = {
  errorCode?: string;
  errorMessage?: string;
  errorName?: string;
};

type BuildEmailVerificationCodePathOptions = {
  email: string;
  redirectPath?: string | null;
};

const EMAIL_VERIFICATION_REQUIRED_CODE = "403107";
const EMAIL_VERIFICATION_REQUIRED_NAME = "email-not-verified";
const EMAIL_VERIFICATION_REQUIRED_MESSAGE =
  "Email verification required. Please verify your email before accessing this resource.";

export const shouldAutoSendEmailOtp = ({
  source,
  otpSentAt,
}: AutoSendEmailOtpOptions) =>
  source === "login" && typeof otpSentAt !== "number";

export const isEmailVerificationRequiredError = ({
  errorCode,
  errorMessage,
  errorName,
}: EmailVerificationRequiredErrorOptions) => {
  const normalizedMessage = errorMessage?.trim().toLowerCase();

  return (
    errorName === EMAIL_VERIFICATION_REQUIRED_NAME ||
    errorCode === EMAIL_VERIFICATION_REQUIRED_CODE ||
    normalizedMessage === EMAIL_VERIFICATION_REQUIRED_MESSAGE.toLowerCase()
  );
};

export const buildEmailVerificationCodePath = ({
  email,
  redirectPath,
}: BuildEmailVerificationCodePathOptions) => {
  const params = new URLSearchParams();
  params.set("email", email);

  if (redirectPath) {
    params.set("redirectTo", redirectPath);
  }

  return `/email-verification-code?${params.toString()}`;
};
